

























import { stepV2 } from '@/enums/donationStepOrder';
import { DonationStep } from '@/interfaces/donationStep';
import { ProgressableStep } from '@/interfaces/progressableStep';
import Vue from 'vue';
export default Vue.extend({
  props: {
    steps: {
      type: Array,
      default: () => [] as Array<DonationStep>,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    stepsProgress(): Array<ProgressableStep> {
      return [
        {
          title: this.t('donationGuide.progress.certificateDetails'),
          isComplete: this.currentStep > stepV2.CERTIFICATE_DETAILS,
          isActive: this.currentStep === stepV2.CERTIFICATE_DETAILS,
        },
        {
          title: this.t('donationGuide.progress.donationDetails'),
          isComplete: this.currentStep > stepV2.CASE,
          isActive: this.currentStep === stepV2.CASE,
        },
        {
          title: this.t('donationGuide.progress.paymentDetails'),
          isComplete: this.currentStep > stepV2.PAYMENT_AND_DELIVERY,
          isActive: this.currentStep === stepV2.PAYMENT_AND_DELIVERY,
        },
        {
          title: this.t('donationGuide.progress.review'),
          isComplete: false, // TODO: Implement that this is marked as completed somehow? When displaying a 'thank you' maybe?
          isActive: this.currentStep >= stepV2.SUMMARY && this.currentStep <= stepV2.PAYMENT_LINK,
        },
      ];
    },
  },
  mounted() {
    this.show = true;
  },
  methods: {
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
